import * as localforage from "localforage"

// Main storage will contain all things that can easily be loaded into memory because they are not so large
// (list markers, settings etc.). For those things we don't need DB query capabilities so localforage "keyvaluepairs"
// is enough. Those things are just loaded into memory and then queried there in normal JavaScript ways.
export const mainStorage = localforage.createInstance({
  name: 'main'
})